import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const VendorSummaryTable = ({ metrics, formatMoney, handleKpiClick }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Vendor-wise Summary</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Vendor</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Total Banks</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Active</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Unassigned</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">In Process</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Freezed</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Freezed Amount</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Assigned</th>
                <th className="text-left p-3 text-sm font-semibold text-slate-600">Closed</th>
              </tr>
            </thead>
            <tbody>
              {metrics?.vendorSummary?.length > 0 ? (
                metrics.vendorSummary.map((vendor) => (
                  <tr key={vendor.vendorId} className="border-b hover:bg-slate-50">
                    <td className="p-3 font-medium">{vendor.vendorName}</td>
                    <td className="p-3 cursor-pointer hover:underline" onClick={() => handleKpiClick(`${vendor.vendorName} - All Banks`, (banks) => banks.filter(b => b.vendorName === vendor.vendorName))}>{vendor.totalBanks}</td>
                    <td className="p-3 text-green-600 font-semibold cursor-pointer hover:underline" onClick={() => handleKpiClick(`${vendor.vendorName} - Active`, (banks) => banks.filter(b => b.vendorName === vendor.vendorName && b.status === 'Active'))}>{vendor.active}</td>
                    <td className="p-3 text-teal-600 font-semibold cursor-pointer hover:underline" onClick={() => handleKpiClick(`${vendor.vendorName} - Unassigned`, (banks) => banks.filter(b => b.vendorName === vendor.vendorName && b.status === 'Unassigned'))}>{vendor.unassigned || 0}</td>
                    <td className="p-3 text-amber-600 font-semibold cursor-pointer hover:underline" onClick={() => handleKpiClick(`${vendor.vendorName} - In Process`, (banks) => banks.filter(b => b.vendorName === vendor.vendorName && b.status === 'In Process'))}>{vendor.inProcess}</td>
                    <td className="p-3 text-red-600 font-semibold cursor-pointer hover:underline" onClick={() => handleKpiClick(`${vendor.vendorName} - Freezed`, (banks) => banks.filter(b => b.vendorName === vendor.vendorName && b.status?.startsWith('Freezed')))}>{vendor.freezed}</td>
                    <td className="p-3 text-red-600 font-semibold cursor-pointer hover:underline" onClick={() => handleKpiClick(`${vendor.vendorName} - Freezed`, (banks) => banks.filter(b => b.vendorName === vendor.vendorName && b.status?.startsWith('Freezed')))}>{formatMoney(vendor.freezedAmount)}</td>
                    <td className="p-3 text-indigo-600 font-semibold cursor-pointer hover:underline" onClick={() => handleKpiClick(`${vendor.vendorName} - Assigned`, (banks) => banks.filter(b => b.vendorName === vendor.vendorName && b.assignedPartnerId))}>
                      {vendor.assigned || 0}
                      {vendor.assignedPartnerBreakdown?.length > 0 && (
                        <div className="flex gap-1 flex-wrap mt-1">
                          {vendor.assignedPartnerBreakdown.map((p) => (
                            <span key={p.partnerId} className="text-[10px] font-normal bg-indigo-50 text-indigo-600 px-1 py-0.5 rounded">{p.partnerName}: {p.count}</span>
                          ))}
                        </div>
                      )}
                    </td>
                    <td className="p-3 text-slate-500 cursor-pointer hover:underline" onClick={() => handleKpiClick(`${vendor.vendorName} - Closed`, (banks) => banks.filter(b => b.vendorName === vendor.vendorName && b.status === 'Closed'))}>{vendor.closed}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="p-8 text-center text-slate-500">
                    No vendors found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

export default VendorSummaryTable;
